export const defaultLanguage = "en";
